import React, { createContext, useMemo } from 'react';
const contextSymbol = typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('__VTP_STOCK_CONTEXT__')
    : '__VTP_STOCK_CONTEXT__';
const resetContext = () => {
    Object.defineProperty(React, contextSymbol, {
        value: createContext(undefined),
        enumerable: false,
        configurable: true,
        writable: false,
    });
};
const getStockContext = () => {
    if (!React[contextSymbol]) {
        resetContext();
    }
    return React[contextSymbol];
};
const StockContextProvider = ({ vehicle, vehicleID, svd, children, }) => {
    const contextValue = useMemo(() => {
        return {
            vehicle,
            vehicleID,
            svd,
        };
    }, [vehicle, vehicleID]);
    return React.createElement(StockContext.Provider, { value: contextValue }, children);
};
const StockContext = getStockContext();
export { StockContext, StockContextProvider };
